// 數值格式化工具。

// 千分位 + 固定兩位小數（金額已由 toClientBalance ÷10000 轉為顯示單位）。
const GROUPED = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

// 千分位整數（對應 Unity LocalizationUtility.ToString(value, "N0")）。
const GROUPED_INT = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

/** 千分位金額顯示，保留兩位小數（例：1000000 → "1,000,000.00"）。 */
export function formatMoney(value: number): string {
  return GROUPED.format(value)
}

/** 千分位整數顯示，無小數（例：30000 → "30,000"）。 */
export function formatInteger(value: number): string {
  return GROUPED_INT.format(value)
}
